import * as Modal from '@radix-ui/react-dialog';
import { useState } from 'react';
import classNames from '@/lib/classNames';
import Button from '../elements/Button';

export type MailingListSignupModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: (name: { firstName: string; lastName: string }) => void;
};

export const MailingListSignupModal = ({ open, onOpenChange, onSubmit }: MailingListSignupModalProps) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubmit({ firstName, lastName });
    };

    return (
        <Modal.Root open={open} onOpenChange={onOpenChange} modal>
            <Modal.Portal>
                <Modal.Overlay className="fixed inset-0 z-40 bg-black/70 data-[state=open]:animate-overlayShow" />
                <Modal.Content className={classNames('z-50 fixed w-full max-w-xs left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] outline-none animate-in px-4')}>
                    <div className="rounded-2xl bg-white p-6 text-primary shadow-xl relative">
                        <Modal.Close className="absolute top-2 right-2 inline-flex h-8 w-8 items-center justify-center rounded-full text-primary/70 hover:bg-black/5 hover:text-primary outline-none">
                            x
                        </Modal.Close>
                        <Modal.Title className="h6 uppercase mb-4">Almost there</Modal.Title>
                        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                            <div>
                                <label className="sr-only" htmlFor="mailing-list-first-name">
                                    First name
                                </label>
                                <input
                                    className="leading-normal w-full rounded-full border border-gray-200 py-4 px-8 text-sm font-medium text-primary"
                                    id="mailing-list-first-name"
                                    type="text"
                                    placeholder="First name"
                                    value={firstName}
                                    onChange={(event) => setFirstName(event.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label className="sr-only" htmlFor="mailing-list-last-name">
                                    Last name
                                </label>
                                <input
                                    className="leading-normal w-full rounded-full border border-gray-200 py-4 px-8 text-sm font-medium text-primary"
                                    id="mailing-list-last-name"
                                    type="text"
                                    placeholder="Last name"
                                    value={lastName}
                                    onChange={(event) => setLastName(event.target.value)}
                                    required
                                />
                            </div>
                            <Button className="px-8" size="sm" colour="primary" variant="outline" type="submit">
                                Subscribe
                            </Button>
                        </form>
                    </div>
                </Modal.Content>
            </Modal.Portal>
        </Modal.Root>
    );
};
